import { Image, Text } from '@dsx/react';
import {
	Footer as DsFooter,
	FooterLinkGroup,
	FooterSection,
	FooterSectionGroup,
	SocialLinks,
	LegalLinks,
	TrackingLink,
} from '@ds-mgnl/marketing';
import footerLogo from '../../assets/images/tels-footer-logo.svg';
import styles from './Footer.module.css';

export const Footer = () => {
	const currentYear = new Date().getFullYear();
	const copyright = `©2009-${currentYear} Direct Supply, Inc. All rights reserved.`;

	return (
		<div className={styles['footer-container']}>
			<DsFooter
				header={
					<TrackingLink
						href="/"
						clickType="footer_link"
						trackingText="Footer Logo"
					>
						<Image
							src={footerLogo}
							alt="DS TELS Logo"
							loading="lazy"
							width="187px"
							height="64px"
						/>
					</TrackingLink>
				}
				subFooter={
					<LegalLinks
						links={[
							{
								children: 'Application Privacy & Legal Information',
								href: '/legal/application-privacy',
							},
							{
								children: 'Terms of Use',
								href: '/legal/terms-of-use',
							},
							{
								children: 'Privacy Policy',
								href: '/legal/privacy-policy',
							},
							{
								children: 'Cookie Policy',
								href: '/legal/cookie-policy',
							},
							{
								children: 'California Collection Notice',
								href: '/legal/privacy-policy#california-collection-notice',
							},
						]}
						copyrightText={copyright}
					/>
				}
			>
				<FooterSectionGroup key="contact-social">
					<FooterSection title="Contact us" columnCount={1} columnWidth="265px">
						<div>
							<Text variant="body-small">Need help or have a question?</Text>
							<TrackingLink
								href="/contact/"
								size="small"
								linkStyle="standalone"
								actionIndicator="MdArrowForward"
								clickType="footer_link"
							>
								Contact us
							</TrackingLink>
						</div>
					</FooterSection>
					<SocialLinks
						links={[
							{
								href: 'https://www.facebook.com/directsupply',
								site: 'facebook',
							},
							{
								href: 'https://twitter.com/_DirectSupply',
								site: 'twitterX',
							},
							{
								href: 'http://www.linkedin.com/company/direct-supply',
								site: 'linkedin',
							},
							{
								href: 'http://www.youtube.com/c/directsupply',
								site: 'youtube',
							},
						]}
					/>
				</FooterSectionGroup>
				<FooterSection
					key="tels"
					title="TELS"
					columnCount={3}
					columnWidth="265px"
				>
					<FooterLinkGroup
						title="Platform"
						links={[
							{
								href: '/building-management-platform/maintenance',
								children: 'Maintenance',
							},
							{
								href: '/building-management-platform/housekeeping',
								children: 'Housekeeping',
							},
							{
								href: '/building-management-platform/capital-management',
								children: 'Capital Management',
							},
							{
								href: '/building-management-platform/unit-turns',
								children: 'Unit Turns',
							},
							{
								href: 'https://www.tels.net/TELSLogin/signin.aspx',
								target: '_blank',
								children: 'Sign in',
							},
						]}
					/>

					<FooterLinkGroup
						title="Services"
						links={[
							{
								href: '/services/routine-and-emergency-repairs',
								children: 'Route and Emergency Repairs',
							},
							{
								href: '/services/planned-projects',
								children: 'Planned Projects',
							},
							{
								href: '/services/recurring-maintenance-programs',
								children: 'Recurring Maintenance Programs',
							},
						]}
					/>
					<FooterLinkGroup
						title="Resources"
						links={[
							{ href: '/resources/blogs', children: 'Expertise' },
							{ href: '/resources/case-studies', children: 'Case Studies' },
						]}
					/>
				</FooterSection>
			</DsFooter>
		</div>
	);
};
